import { useRef } from "react";
import { gsap, SplitText, useGSAP, MOTION_OK, sel } from "../lib/motion";
import { profile } from "../data/profile";
import s from "./About.module.css";

export default function About() {
  const root = useRef<HTMLElement>(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        // The headline inks in word by word at reading pace, tied to scroll.
        SplitText.create(sel(s.headline), {
          type: "words",
          autoSplit: true,
          onSplit: (self) =>
            gsap.fromTo(
              self.words,
              { opacity: 0.22 },
              {
                opacity: 1,
                ease: "none",
                stagger: 0.12,
                scrollTrigger: { trigger: sel(s.headline), start: "top 82%", end: "bottom 48%", scrub: 0.4 },
              }
            ),
        });

        gsap.from(`${sel(s.detail)} > *`, {
          autoAlpha: 0,
          y: 28,
          duration: 0.9,
          ease: "expo.out",
          stagger: 0.12,
          scrollTrigger: { trigger: sel(s.detail), start: "top 85%", once: true },
        });
      });
    },
    { scope: root }
  );

  return (
    <section ref={root} id="about" className={`section ${s.about}`} aria-labelledby="about-title">
      <div className="container">
        <h2 id="about-title" className="visually-hidden">
          About
        </h2>
        <p className={s.headline}>{profile.headline}</p>

        <div className={s.detail}>
          <p className={s.body}>{profile.about}</p>
          <dl className={s.facts}>
            {profile.facts.map((f) => (
              <div key={f.label} className={s.fact}>
                <dt>{f.label}</dt>
                <dd>{f.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
